import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Retorna TRUE se o array de dados se parecer com o BANCARIO TUNA.
 */
export const detectar = (dadosArray) => {
    // O cabeçalho bancário costuma estar na linha 4 ou 5
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().replace(/^\uFEFF/, '').toLowerCase());
        
        if (
            cleanRow.includes('data lançamento') && 
            cleanRow.includes('histórico') && 
            cleanRow.includes('descrição') &&
            cleanRow.includes('valor')
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa o extrato bancário (BANCARIO TUNA) extraindo as entradas na conta.
 */
export const processar = (dadosArray) => {
    let idxData = -1;
    let idxValor = -1;
    let idxDescricao = -1;
    let idxHistorico = -1;
    let idxCabecalho = -1;

    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().replace(/^\uFEFF/, '').toLowerCase());
        
        const possibleDataIdx = cleanRow.indexOf('data lançamento');
        const possibleValorIdx = cleanRow.indexOf('valor');
        const possibleDescIdx = cleanRow.indexOf('descrição');
        const possibleHistIdx = cleanRow.indexOf('histórico');

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1 && possibleDescIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxValor = possibleValorIdx;
            idxDescricao = possibleDescIdx;
            idxHistorico = possibleHistIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho Extrato Bancário não encontrado.');
    }

    const extratos = [];

    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || !linha[idxData]) continue;

        // Foca apenas nos repasses da Tuna Pagamentos
        const descricaoRaw = String(linha[idxDescricao] || '').trim().toLowerCase();
        if (!descricaoRaw.includes('tuna')) continue;

        const rawDate = String(linha[idxData]).trim();
        if (!rawDate) continue;

        let isoDate = rawDate;
        if (rawDate.includes('/')) {
            const parts = rawDate.split('/');
            isoDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        const valorTexto = String(linha[idxValor] || '');
        const valorLiquido = parseFloat(valorTexto.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.')) || 0;

        // Só considera entradas positivas
        if (valorLiquido > 0) {
            extratos.push({
                data: isoDate,
                valor: valorLiquido,
                descricao: String(linha[idxDescricao] || '').trim(),
                historico: idxHistorico !== -1 ? String(linha[idxHistorico] || '').trim() : '',
                tipo: 'Crédito'
            });
        }
    }

    return extratos;
};
